
declare var jQuery: any;

export class MenuUtility{    
    
    constructor(){}

    static selectOption(id : string) : void {
                
        jQuery(".sidebar-menu ul li").removeClass("active");
        if(id!=null){
            jQuery("#" + id).addClass("active");
        }       

    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/utilities/menu.utility.ts